import { init } from "next/dist/compiled/@vercel/og/satori";
import { userStore } from "../ducks/user";
import { wsConnectionStore } from "../ducks/wsConnection";
import {
  getDelay,
  incrRetries,
  initWebsocketConnect,
  useLongPolling,
} from "./websocket";
import { routeIncommingMessage } from "./wsInRoutes";

// export async function longPollingLogin() {
//   const { username, isGuest, id, room } = userStore.getState();
//   const { longPollingUrl } = wsConnectionStore.getState();

//   import("../ducks/gamePlay").then(async ({ gamePlayStore }) => {
//     const { gameId } = gamePlayStore.getState();

//     try {
//       const sessionId = sessionStorage.getItem("sessionId");

//       const user = {
//         username,
//         isGuest,
//         userId: id,
//         room,
//         gameId,
//         sessionId,
//       };

//       const response = await fetch(`${longPollingUrl}/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(user),
//       });

//       if (!response.ok) {
//         return;
//       }
//     } catch (e) {
//       console.log(e);
//     }
//   });
// }

export async function longPollingGetRequest(
  username: string,
  sessionId: string
) {
  const { longPollingUrl } = wsConnectionStore.getState();

  try {
    const response = await fetch(
      `${longPollingUrl}/long-polling?username=${username}&sessionId=${sessionId}`
    );

    if (response.ok == false) {
      console.log("error", response.status);
      initWebsocketConnect();
      return;
    }
    const data = await response.json();
    if (data.error) {
      console.log("error", data.error);
      if (data.error == "PLAYER_NOT_FOUND") {
        console.log("player not found reconnect with websocket");
      }
      return;
    }
    if (data?.cmd && data.cmd != "NO_DATA") {
      // setTimeout(() => {
      routeIncommingMessage(data);
      // }, 5000);
    }
    if (useLongPolling) {
      longPollingGetRequest(username, sessionId);
    }
  } catch (e) {
    // setTimeout(() => {
    //   incrRetries();
    //   longPollingGetRequest(username, sessionId);
    // }, getDelay());
    console.log(e);
  }
}

export async function longPollingPostRequest(message: object) {
  const username = userStore.getState().username;
  const sessionId = sessionStorage.getItem("sessionId");
  const { longPollingUrl } = wsConnectionStore.getState();
  try {
    const response = await fetch(`${longPollingUrl}/command`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username,
        sessionId,
        message,
      }),
    });

    if (!response.ok) {
      return;
    }
  } catch (e) {
    console.log(e);
  }
}
